import "./myPrescriptions.scss";
import React, { useContext , useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, Container, Grid, CardContent} from "@mui/material";
import { PageLayoutDoctor } from "../../../components/page/page-layout-doctor";
/* import { Budget } from "../../components/dashboard/budget";
import { AppsListToolbar } from "../../components/dashboard/apps-list-toolbar";
import { AppsListResults } from "../../components/dashboard/app-list-results";
import { DialogComponent } from "../../components/dialog-component"; */
import { GlobalContext } from "../../../context/Provider";
import getAplications from "../../../context/actions/aplications/getAplications";
import WelcomeCard from "../../../components/doctor/welcome-card/WelcomeCard";

const MyPrescriptions = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [titleDialog, setTitleDialog] = React.useState("");
  const [bodyDialog, setBodyDialog] = React.useState("");
  const { aplicationsDispatch, aplicationsState } = useContext(GlobalContext);

  const {
    aplications: { data, loading },
  } = aplicationsState;

  useEffect(() => {
    getAplications()(aplicationsDispatch);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const executeAction = (action, data) => {
     if (action === "accept-dialog") {
       setOpen(false);
     } else if (action === "desactivar") {
       setTitleDialog("Deshabilitar cliente app");
       setBodyDialog(
         <p>
           ¿Confirma que desea deshabilitar el cliente de app{" "}
           <span style={{ fontWeight: "600" }}>
             {data.appName}
           </span>
           ?
         </p>
       );
       setOpen(true);
     } else if (action === "activar") {
       setTitleDialog("Habilitar cliente app");
       setBodyDialog(
         <p>
           ¿Confirma que desea habilitar el cliente de app{" "}
           <span style={{ fontWeight: "600" }}>
             {data.appName}
           </span>
           ?
         </p>
       );
       setOpen(true);
     } else if (action === "agregar") {
       navigate("/clients/new");
     } else if (action === "view") {
       navigate(`/clients/${data.id}`);
     }
  }

  return (
    <PageLayoutDoctor>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
        <WelcomeCard
            title="Mis prescripciones"
            subtitle="Gestión de prescripciones médicas"
          />
        </Container>
      </Box>
    </PageLayoutDoctor>
  );

};


export default MyPrescriptions;
